export const LOAD_VIN_HISTORY = 'vin/load-history';
export const FETCH_VIN_HISTORY = 'vin/fetch-history';
export const SET_VIN_HISTORY = 'vin/set-history';
export const ADD_VIN_ITEM = 'vin/add-item';
export const UPDATE_VIN_ITEM = 'vin/update-item';
export const SHOW_VIN_HISTORY = 'vin/show-history';
export const HIDE_VIN_HISTORY = 'vin/hide-history';
export const SET_VIN_FETCH_ERROR = 'vin/set-fetch_error';
export const RESET_VIN_FETCH_ERROR = 'vin/reset-fetch_error';
